// extracted by mini-css-extract-plugin
export default {"footer":"jZ_2S0","mobileFooter":"V16SQo","container":"bvO3oL"};